import { render, staticRenderFns } from "./NuevaPropuesta.vue?vue&type=template&id=44c3b479&scoped=true&"
import script from "./NuevaPropuesta.vue?vue&type=script&lang=js&"
export * from "./NuevaPropuesta.vue?vue&type=script&lang=js&"
import style0 from "./NuevaPropuesta.vue?vue&type=style&index=0&id=44c3b479&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c3b479",
  null
  
)

export default component.exports